// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2o8a5","title":"Info_title__l2OET","selects":"Info_selects__3OqL-","requiredAsterisk":"Info_requiredAsterisk__1u9-p"};